import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { closeModal } from "../../../redux/slice/modalSlice";
import { RootState } from "../../../redux/store/store";
import NewTabElements from "../../newTabElements/newTabElements";

interface TabData {
  id: string;
  label: string;
  children: React.ReactNode;
}

interface OrderProcessingInfoMetaData {
  tabs: TabData[];
  title: string;
}

const OrderProcessingInfo = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<string>("");

  const metaData = useSelector(
    (state: RootState) => state.modal.metaData,
  ) as OrderProcessingInfoMetaData;
  const tabs: TabData[] = metaData?.tabs || [];
  const title = metaData?.title;

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    if (tabs && tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].id);
    }
  }, [tabs, activeTab]);

  const renderTabContent = () => {
    const currentTab = tabs.find((tab) => tab.id === activeTab);
    return currentTab?.children || null;
  };

  const tabElements = useMemo(
    () =>
      tabs.map((tab) => ({
        id: tab.id,
        label: tab.label,
      })),
    [tabs],
  );

  return (
    <Modal
      dialogId={ModalId.ORDER_PROCESSING_INFO_MODAL}
      title={title || "Order Processing Info"}
      onClose={handleClose}
      onCancel={handleClose}
      heightPercentage={50}
      onSave={handleSave}
      saveButtonText="Save"
      cancelText="Cancel"
      hideFooter={true}
    >
      <div className="order-processing-info-modal flex h-full flex-col overflow-hidden">
        <div className="tabs-container mb-4 flex flex-shrink-0 gap-2 border-b border-primaryGray-16">
          <NewTabElements
            tabs={tabElements}
            activeTab={activeTab}
            onTabChange={(tab) => setActiveTab(tab)}
          />
        </div>

        <div
          className="tab-content flex-1 overflow-y-auto overflow-x-hidden"
          style={{ maxHeight: "calc(80vh - 140px)" }}
        >
          {renderTabContent()}
        </div>
      </div>
    </Modal>
  );
};

export default OrderProcessingInfo;
